import assign from 'lodash.assign';
export class EconomicOperatorRole {
    constructor(init) {
        assign(this, init);
    }
    roleCode;
    roleDescription;
}
